<h2>Stats per Customer</h2>

<p>You can optionally filter on certain dates, both start and end date are inclusive.</p>
<mat-form-field>
  <input matInput [matDatepicker]="picker" placeholder="Start Date" [(ngModel)]="fromDate" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
<mat-form-field>
  <input matInput [matDatepicker]="picker2" placeholder="End Date" [(ngModel)]="endDate" />
  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
  <mat-datepicker #picker2></mat-datepicker>
</mat-form-field>

<button mat-raised-button (click)="clearDates()">Clear Dates</button>
<button mat-raised-button (click)="currentMonth()">Current Month</button>
<button mat-raised-button (click)="lastMonth()">Last Month</button>

<mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="name">
    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef> Customer </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="customerId">
    <mat-header-cell mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element">
      <!-- Empty guids are used for non-assigned clients -->
      @if (element.customerId !== '00000000-0000-0000-0000-000000000000') {
      {{ element.customerId }}
      }
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="conversions">
    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef> Conversions </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.conversions | number : '1.0-0' }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="percentage">
    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef> Percentage </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.percentage | number : '2.2-2' }} % </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['name', 'customerId', 'conversions', 'percentage']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['name', 'customerId', 'conversions', 'percentage']"></mat-row>
</mat-table>

<div class="total">
  <strong>Total conversions: </strong>
  <span>{{ totalConversions() || 0 | number : '1.0-0' }}</span>
</div>
